import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Trophy, Gift, ArrowRight } from 'lucide-react';
import SEO from '../components/SEO';
import Banner from '../components/Banner';
import SonKazanclar from '../components/SonKazanclar';
import PopulerOyunlar from '../components/PopulerOyunlar';
import KonusulanOyunlar from '../components/KonusulanOyunlar';
import KonusulanSporlar from '../components/KonusulanSporlar';
import CanliBahisHareketleri from '../components/CanliBahisHareketleri';

const Etkinlikler: React.FC = () => {
  const quickLinks = [
    {
      title: 'Turnuvalar',
      description: 'Heyecan verici turnuvalara katılın',
      icon: Trophy,
      path: '/etkinlikler/turnuvalar',
      color: 'from-yellow-500 to-orange-500'
    },
    {
      title: 'Promosyonlar',
      description: 'Özel bonuslardan yararlanın',
      icon: Gift,
      path: '/etkinlikler/promosyonlar',
      color: 'from-purple-500 to-pink-500'
    }
  ];

  return (
    <>
      <SEO
        title="Casibom Bet | En İyi Casino ve Bahis Deneyimi"
        description="Casibom Bet - En popüler slot oyunları, canlı casino ve spor bahisleri. Büyük kazançlar ve özel promosyonlar sizi bekliyor."
        url="/"
      />
      <div className="min-h-screen pt-28 pb-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          {/* Banner Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="mb-8 mt-4"
          >
            <Banner />
          </motion.div>

          {/* Quick Links - Turnuvalar & Promosyonlar */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8"
          >
            {quickLinks.map((item, index) => {
              const Icon = item.icon;
              return (
                <Link
                  key={index}
                  to={item.path}
                  className="group flex items-center space-x-4 bg-dark-800/50 backdrop-blur-sm rounded-xl p-4 border border-dark-700 hover:border-primary-500/50 transition-all duration-300"
                >
                  <div className={`w-14 h-14 rounded-xl bg-gradient-to-r ${item.color} flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                    <Icon className="w-7 h-7 text-white" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-bold text-white group-hover:text-primary-400 transition-colors">
                      {item.title}
                    </h3>
                    <p className="text-gray-400 text-sm">{item.description}</p>
                  </div>
                  <ArrowRight className="w-5 h-5 text-gray-400 group-hover:text-primary-400 group-hover:translate-x-1 transition-all" />
                </Link>
              );
            })}
          </motion.div>

          {/* Main Content Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 items-stretch">

            {/* Sol Kolon - Son Kazançlar */}
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="lg:col-span-1 h-full"
            >
              <SonKazanclar />
            </motion.div>

            {/* Sağ Kolon - Popüler Oyunlar (geniş) */}
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="lg:col-span-2 h-full"
            >
              <PopulerOyunlar />
            </motion.div>

          </div>

          {/* Alt Bölüm - Konuşulan Oyunlar & Sporlar */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6 items-stretch">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="h-full"
            >
              <KonusulanOyunlar />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              className="h-full"
            >
              <KonusulanSporlar />
            </motion.div>
          </div>

          {/* Canlı Bahis Hareketleri - Full Width */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="mt-6"
          >
            <CanliBahisHareketleri />
          </motion.div>

        </div>
      </div>
    </>
  );
};

export default Etkinlikler;
